import { lazy } from 'react'
import SRQ20WomanWavingHave from './ilustrations/srq20-woman-waving-hand'

const ArrowRight = lazy(() => import('./icons/arrow-right'))
const ArrowDown = lazy(() => import('./icons/arrow-down'))
const ArrowUp = lazy(() => import('./icons/arrow-up'))
const ArrowLeft = lazy(() => import('./icons/arrow-left'))
const Search = lazy(() => import('./icons/search'))
const Loading = lazy(() => import('./icons/loading'))
const Star = lazy(() => import('./icons/star'))
const StarFilled = lazy(() => import('./icons/star-filled'))
const Close = lazy(() => import('./icons/close'))
const FileBlank = lazy(() => import('./icons/file-blank'))
const ArrowGroup = lazy(() => import('./icons/arrow-group'))
const Silhouette = lazy(() => import('./icons/silhouette'))
const Info = lazy(() => import('./icons/info'))
const Trash = lazy(() => import('./icons/trash'))
const AttachCircle = lazy(() => import('./icons/attach-circle'))
const Check = lazy(() => import('./icons/check'))
const Amex = lazy(() => import('./icons/amex'))
const Visa = lazy(() => import('./icons/visa'))
const MasterCard = lazy(() => import('./icons/mastercard'))
const NewCard = lazy(() => import('./icons/new-card'))
const Brain = lazy(() => import('./icons/brain'))
const Minimize = lazy(() => import('./icons/minimize'))
const Maximize = lazy(() => import('./icons/maximize'))
const ClariLogo = lazy(() => import('./icons/clari-logo'))
const ClariClose = lazy(() => import('./icons/clari-close'))

// Ilustrations

const PViva = lazy(() => import('./ilustrations/pv'))
const UpdateAccountDataRibon = lazy(() =>
  import('./ilustrations/update-account-ribon'),
)
const ManDoingThumbsUpWithHisHand = lazy(() =>
  import('./ilustrations/man-doing-thumbs-up-with-his-hand'),
)
const WomanSittingInDoubt = lazy(() =>
  import('./ilustrations/woman-sitting-in-doubt'),
)
const MentalHealthAttendance = lazy(() =>
  import('./ilustrations/mental-health-attendance'),
)

const QuestionaryWoman = lazy(() =>
  import('./ilustrations/srq20-questionary-woman'),
)

const QuestionaryResultGood = lazy(() =>
  import('./ilustrations/srq20-result-feeling-good'),
)

const QuestionaryResultLightSuffering = lazy(() =>
  import('./ilustrations/srq20-result-light-suffering'),
)

const QuestionaryResultModerateSuffering = lazy(() =>
  import('./ilustrations/srq20-result-moderate-suffering'),
)

const QuestionaryResultSevereSuffering = lazy(() =>
  import('./ilustrations/srq20-result-severe-suffering'),
)

const QuestionaryResultMobileGood = lazy(() =>
  import('./ilustrations/srq20-result-mobile-feeling-good'),
)

const QuestionaryResultMobileLightSuffering = lazy(() =>
  import('./ilustrations/srq20-result-mobile-light-suffering'),
)

const QuestionaryResultMobileModerateSuffering = lazy(() =>
  import('./ilustrations/srq20-result-mobile-moderate-suffering'),
)

const QuestionaryResultMobileSevereSuffering = lazy(() =>
  import('./ilustrations/srq20-result-mobile-severe-suffering'),
)

const AnimatedMentalHealthSearch = lazy(() =>
  import('./ilustrations/animated-mental-health-search'),
)

export default {
  icons: {
    'arrow-right': ArrowRight,
    'arrow-group': ArrowGroup,
    'arrow-down': ArrowDown,
    'arrow-up': ArrowUp,
    star: Star,
    'star-filled': StarFilled,
    close: Close,
    search: Search,
    loading: Loading,
    'arrow-left': ArrowLeft,
    'file-blank': FileBlank,
    trash: Trash,
    check: Check,
    amex: Amex,
    visa: Visa,
    mastercard: MasterCard,
    'new-card': NewCard,
    brain: Brain,
    'clari-logo': ClariLogo,
    maximize: Maximize,
    minimize: Minimize,
    'clari-close': ClariClose,
  },
  illustrations: {
    silhouette: Silhouette,
    info: Info,
    pviva: PViva,
    'man-doing-thumbs-with-his-hand': ManDoingThumbsUpWithHisHand,
    'attach-circle': AttachCircle,
    'characters-talking-conexa-ribon': UpdateAccountDataRibon,
    'woman-sitting-in-doubt': WomanSittingInDoubt,
    'srq20-questionary-woman': QuestionaryWoman,
    'srq20-result-good': QuestionaryResultGood,
    'srq20-result-light-suffering': QuestionaryResultLightSuffering,
    'srq20-result-moderate-suffering': QuestionaryResultModerateSuffering,
    'srq20-result-severe-suffering': QuestionaryResultSevereSuffering,
    'srq20-result-mobile-good': QuestionaryResultMobileGood,
    'srq20-result-mobile-light-suffering':
      QuestionaryResultMobileLightSuffering,
    'srq20-result-mobile-moderate-suffering':
      QuestionaryResultMobileModerateSuffering,
    'srq20-result-mobile-severe-suffering':
      QuestionaryResultMobileSevereSuffering,
    'mental-health-attendance': MentalHealthAttendance,
    'srq20-woman-waving-hand': SRQ20WomanWavingHave,
    'animated-mental-health-search': AnimatedMentalHealthSearch,
  },
}
